import { TAppState } from '../types/appState';

export const countClosedChatsSelector = (state: TAppState) => state.chatWindow.countClosedChats;
